// import React, { useState } from "react";
// import classNames from "classnames";
// import { Container, Row, Col } from "@101internet/styles";
// import { withStyles } from "@101internet/styles";
// import SwitchCityWindowContainer from "Containers/SwitchCityWindowContainer";
// import LoginHeaderContainer from "Containers/LoginHeaderContainer";
// import DeclinationContainer from "Containers/DeclinationContainer";
// import LoginLogic from "HOC/LoginLogic";
// import PhoneContainerNew from "Containers/PhoneContainerNew";
// import { MobileOperators } from "./Operators";
// import { Nomera } from "./Nomera";
// import { Tarify } from "./Tarify";
// import { SimKarty } from "./SimKarty";
// import { Providers } from "./Providers";
// import { Link, useParams } from "react-router-dom";
// import { generateUrl } from "Services/withDefaultParams";
// import Routes from "Configs/routes";
// import useDefaultParams from "Services/useDefaultParams";

// const styles = theme => {
//     return {
//         root: {
//             visibility: "visible",
//             opacity: 1,
//             transition: "opacity .3s ease",
//             position: "absolute",
//             bottom: "-20px",
//             transform: "translateY(100%)",
//             width: "380px",
//             background: theme.palette.colors.paleGrey,
//             boxShadow: "0 2px 10px 0 rgba(0, 0, 0, 0.5)",
//             borderRadius: "10px",
//             right: "10px",
//             padding: "15px 20px 30px"
//         },
//         menuRoot: {
//             backgroundColor: theme.palette.colors.white,
//             borderRadius: "5px",
//             border: `1px solid ${theme.palette.colors.superLightGrey}`,
//             // boxShadow: "0px 4px 13px rgba(0, 0, 0, 0.17)",
//             fontSize: "14px",
//             color: theme.palette.colors.darkSlateBlue2
//         },
//         menuItemRoot: {
//             position: "relative",
//             zIndex: 10,
//             height: "40px",
//             // paddingLeft: "18px",
//             lineHeight: "40px",
//             "&.expanded": {
//                 height: "auto",
//                 "& > $menuItemChildWrapper": {
//                     display: "block",
//                     boxShadow:
//                         "inset 0 15px 15px -15px rgba(0,0,0,0.2), inset 0 -15px 15px -15px rgba(0,0,0,0.2)",
//                     "& > $menuItemRoot": {
//                         // paddingLeft: "0"
//                     }
//                 }
//             }
//         },
//         menItemName: {
//             color: theme.palette.colors.darkSlateBlue2,
//             display: "block",
//             paddingLeft: "18px",
//             whiteSpace: "nowrap",
//             overflow: "hidden"
//         },
//         menuItemChildWrapper: {
//             display: "none",
//             "& > div": {
//                 borderTop: `1px solid ${theme.palette.colors.superLightGrey}`
//             }
//         },
//         menuItemRootNav: {
//             position: "absolute",
//             zIndex: 1,
//             right: "18px",
//             top: 0,
//             lineHeight: "40px",
//             fontSize: "16px",
//             color: theme.palette.colors.cloudyBlue
//         },
//         menuItemRootFirst: {
//             borderRadius: "5px 5px 0px 0px"
//             // boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.17)"
//         },
//         menuItemRootMiddle: {
//             borderTop: `1px solid ${theme.palette.colors.superLightGrey}`
//             // boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.17)"
//         },
//         menuItemRootLast: {
//             borderTop: `1px solid ${theme.palette.colors.superLightGrey}`
//             // boxShadow: "0px 0px 4px rgba(0, 0, 0, 0.17)"
//         },
//         phoneRoot: {
//             position: "relative",
//             backgroundColor: theme.palette.colors.white,
//             borderRadius: "5px",
//             border: `1px solid ${theme.palette.colors.superLightGrey}`,
//             fontSize: "16px",
//             color: "#5813fe",
//             height: "40px",
//             lineHeight: "40px",
//             paddingLeft: "18px",
//             marginBottom: "15px",
//             "& .icon-call": {
//                 position: "absolute",
//                 fontSize: "20px",
//                 left: "16px",
//                 top: "0px",
//                 lineHeight: "40px"
//             },
//             "& a": {
//                 display: "block",
//                 marginLeft: "26px",
//                 color: "#5813fe"
//             }
//         },
//         showMobile: {
//             borderRadius: "0px 0px 5px 5px"
//         },
//         wrapperUpperPart: {
//             padding: "10px 0",
//             display: "flex",
//             alignItems: "center"
//         },
//         wrapperBottomPart: {
//             padding: "20px 0px"
//         },
//         location: {
//             width: "100%"
//         },
//         upperMenu: {
//             maxWidth: "100%",
//             display: "flex",
//             justifyContent: "center",
//             marginBottom: "30px"
//         },
//         phoneButton: {
//             display: "none"
//         },
//         login: {
//             marginTop: "15px",
//             display: "flex",
//             justifyContent: "center",
//             width: "100%"
//         },
//         mobileMenu: {
//             display: "block",
//             marginLeft: "auto",
//             flexShrink: 0,
//             cursor: "pointer",
//             "& span": {
//                 fontSize: "24px",
//                 color: theme.palette.colors.purplishBlue
//             }
//         },
//         hidden: {
//             transform: "translateX(100%)",
//             visibility: "hidden",
//             opacity: 0
//         },
//         [`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
//             root: {
//                 right: "5px"
//             }
//         },
//         [`@media (max-width: ${theme.media.sm})`]: {
//             root: {
//                 display: "block",
//                 transform: "translateX(0)",
//                 transition: "transform .3s ease",
//                 position: "fixed",
//                 left: 0,
//                 right: 0,
//                 top: 0,
//                 bottom: 0,
//                 backgroundColor: theme.palette.colors.paleGrey,
//                 zIndex: 10000,
//                 boxShadow: "none",
//                 width: "100%",
//                 padding: 0,
//                 borderRadius: 0
//             },
//             hidden: {
//                 transform: "translateX(100%)"
//             },
//             wrapperUpperPart: {
//                 padding: "10px 0",
//                 display: "flex",
//                 alignItems: "center"
//             },
//             wrapperBottomPart: {
//                 paddingTop: "20px",
//                 maxHeight: "calc(100vh - 80px)",
//                 overflow: "scroll"
//             },
//             login: {
//                 flexShrink: 0
//             },
//             phoneButton: {
//                 width: "40px",
//                 flexShrink: 0,
//                 marginLeft: "auto",
//                 display: "block"
//             },
//             location: {
//                 width: "auto",
//                 paddingLeft: 0,
//                 minWidth: "10px",
//                 justifyContent: "flex-start"
//             },
//             mobileMenu: {
//                 display: "flex",
//                 height: "40px",
//                 width: "40px",
//                 alignItems: "center",
//                 justifyContent: "flex-end",
//                 cursor: "pointer",
//                 "& span": {
//                     fontSize: "16px",
//                     color: theme.palette.colors.purplishBlue
//                 }
//             },
//             upperMenu: {
//                 maxWidth: "100%",
//                 display: "flex",
//                 justifyContent: "center",
//                 marginBottom: "30px"
//             }
//         }
//     };
// };

// const MobileWindow = ({ classes, closeMobileMenu, onClickHandler, show }) => {
//     const routeParams = useParams();
//     const { regionUrl } = useDefaultParams(routeParams);

//     const [expandedMobile, setExpandedMobile] = useState(true);
//     const [expandedHome, setExpandedHome] = useState(true);

//     return (
//         <div
//             className={classNames(classes.root, {
//                 [classes.hidden]: !show
//             })}
//         >
//             <Container>
//                 <Row>
//                     <Col xs="12">
//                         <div className={classes.wrapperUpperPart}>
//                             <div className={classes.location}>
//                                 <SwitchCityWindowContainer
//                                     mobileMenu
//                                     purpleTheme={true}
//                                     clickCallback={closeMobileMenu}
//                                 />
//                             </div>
//                             <div
//                                 className={classes.mobileMenu}
//                                 onClick={closeMobileMenu}
//                             >
//                                 <span className="icon24 icon-close" />
//                             </div>
//                         </div>
//                         <div className={classes.wrapperBottomPart}>
//                             <div className={classes.phoneRoot}>
//                                 <span className="icon24 icon-call" />
//                                 <PhoneContainerNew
//                                     withoutIcon={true}
//                                     onClick={onClickHandler}
//                                     roistatClass={"roistat-phone"}
//                                 />
//                             </div>
//                             <div className={classes.menuRoot}>
//                                 <div
//                                     className={classNames(
//                                         classes.menuItemRoot,
//                                         classes.menuItemRootFirst,
//                                         { expanded: expandedHome }
//                                     )}
//                                 >
//                                     <div
//                                         onClick={() =>
//                                             setExpandedHome(!expandedHome)
//                                         }
//                                     >
//                                         <span className={classes.menItemName}>
//                                             Интернет в квартиру
//                                         </span>
//                                     </div>
//                                     <span
//                                         onClick={() =>
//                                             setExpandedHome(!expandedHome)
//                                         }
//                                         className={classNames(
//                                             classes.menuItemRootNav,
//                                             "icon24",
//                                             {
//                                                 "icon-arrow-1-up": expandedHome,
//                                                 "icon-arrow-1-down": !expandedHome
//                                             }
//                                         )}
//                                     />
//                                     <div
//                                         className={classNames(
//                                             classes.menuItemChildWrapper
//                                         )}
//                                     >
//                                         <div
//                                             className={classNames(
//                                                 classes.menuItemRoot
//                                             )}
//                                         >
//                                             <div>
//                                                 <Link
//                                                     className={
//                                                         classes.menItemName
//                                                     }
//                                                     onClick={closeMobileMenu}
//                                                     to={generateUrl(
//                                                         Routes.OrderToHome
//                                                             .route,
//                                                         {
//                                                             regionUrl: regionUrl
//                                                         }
//                                                     )}
//                                                 >
//                                                     Поиск провайдера по адресу
//                                                 </Link>
//                                             </div>
//                                         </div>
//                                         <div
//                                             className={classNames(
//                                                 classes.menuItemRoot
//                                             )}
//                                         >
//                                             <div>
//                                                 <Link
//                                                     className={
//                                                         classes.menItemName
//                                                     }
//                                                     onClick={closeMobileMenu}
//                                                     to={generateUrl(
//                                                         Routes.Rating.route,
//                                                         {
//                                                             regionUrl: regionUrl
//                                                         }
//                                                     )}
//                                                 >
//                                                     Рейтинг
//                                                 </Link>
//                                             </div>
//                                         </div>
//                                         <div
//                                             className={classNames(
//                                                 classes.menuItemRoot
//                                             )}
//                                         >
//                                             <div>
//                                                 <Link
//                                                     className={
//                                                         classes.menItemName
//                                                     }
//                                                     onClick={closeMobileMenu}
//                                                     to={generateUrl(
//                                                         Routes.Exclusive.route,
//                                                         {
//                                                             regionUrl: regionUrl
//                                                         }
//                                                     )}
//                                                 >
//                                                     Выгодные тарифы
//                                                 </Link>
//                                             </div>
//                                         </div>
//                                         <div
//                                             className={classNames(
//                                                 classes.menuItemRoot
//                                             )}
//                                         >
//                                             <div>
//                                                 <Link
//                                                     className={
//                                                         classes.menItemName
//                                                     }
//                                                     onClick={closeMobileMenu}
//                                                     to={generateUrl(
//                                                         Routes.AddressDistricts
//                                                             .route,
//                                                         {
//                                                             regionUrl: regionUrl
//                                                         }
//                                                     )}
//                                                 >
//                                                     <DeclinationContainer
//                                                         type="prepositional"
//                                                         preString="Поиск по адресу в "
//                                                     />
//                                                 </Link>
//                                             </div>
//                                         </div>
//                                         <div
//                                             className={classNames(
//                                                 classes.menuItemRoot
//                                             )}
//                                         >
//                                             <div>
//                                                 <Link
//                                                     className={
//                                                         classes.menItemName
//                                                     }
//                                                     onClick={closeMobileMenu}
//                                                     to={generateUrl(
//                                                         Routes.Rates.route,
//                                                         {
//                                                             regionUrl: regionUrl
//                                                         }
//                                                     )}
//                                                 >
//                                                     Тарифы
//                                                 </Link>
//                                             </div>
//                                         </div>
//                                         <div
//                                             className={classNames(
//                                                 classes.menuItemRoot
//                                             )}
//                                         >
//                                             <div>
//                                                 <Link
//                                                     className={
//                                                         classes.menItemName
//                                                     }
//                                                     onClick={closeMobileMenu}
//                                                     to={generateUrl(
//                                                         Routes.Reviews.route,
//                                                         {
//                                                             regionUrl: regionUrl
//                                                         }
//                                                     )}
//                                                 >
//                                                     Отзывы
//                                                 </Link>
//                                             </div>
//                                         </div>
//                                         <Providers
//                                             classes={classes}
//                                             onClick={closeMobileMenu}
//                                         />
//                                     </div>
//                                 </div>
//                                 <div
//                                     className={classNames(
//                                         classes.menuItemRoot,
//                                         classes.menuItemRootMiddle,
//                                         { expanded: expandedMobile }
//                                     )}
//                                 >
//                                     <div
//                                         onClick={() =>
//                                             setExpandedMobile(!expandedMobile)
//                                         }
//                                     >
//                                         <span className={classes.menItemName}>
//                                             Мобильная связь
//                                         </span>
//                                     </div>
//                                     <span
//                                         onClick={() =>
//                                             setExpandedMobile(!expandedMobile)
//                                         }
//                                         className={classNames(
//                                             classes.menuItemRootNav,
//                                             "icon24",
//                                             {
//                                                 "icon-arrow-1-down": !expandedMobile,
//                                                 "icon-arrow-1-up": expandedMobile
//                                             }
//                                         )}
//                                     />
//                                     <div
//                                         className={classNames(
//                                             classes.menuItemChildWrapper
//                                         )}
//                                     >
//                                         <SimKarty
//                                             classes={classes}
//                                             onClick={closeMobileMenu}
//                                         />
//                                         <Tarify
//                                             classes={classes}
//                                             onClick={closeMobileMenu}
//                                         />
//                                         <Nomera
//                                             classes={classes}
//                                             onClick={closeMobileMenu}
//                                         />
//                                         <MobileOperators
//                                             classes={classes}
//                                             onClick={closeMobileMenu}
//                                         />
//                                     </div>
//                                 </div>
//                                 <div
//                                     className={classNames(
//                                         classes.menuItemRoot,
//                                         classes.menuItemRootMiddle
//                                     )}
//                                 >
//                                     <div>
//                                         <Link
//                                             className={classes.menItemName}
//                                             onClick={closeMobileMenu}
//                                             to={generateUrl(
//                                                 Routes.OrderOuthome.route,
//                                                 {
//                                                     regionUrl: regionUrl
//                                                 }
//                                             )}
//                                         >
//                                             Интернет на дачу
//                                         </Link>
//                                     </div>
//                                 </div>
//                                 <div
//                                     className={classNames(
//                                         classes.menuItemRoot,
//                                         classes.menuItemRootLast
//                                     )}
//                                 >
//                                     <div>
//                                         <Link
//                                             className={classes.menItemName}
//                                             onClick={closeMobileMenu}
//                                             to={generateUrl(
//                                                 Routes.OrderOffice.route,
//                                                 {
//                                                     regionUrl: regionUrl
//                                                 }
//                                             )}
//                                         >
//                                             Интернет в офис
//                                         </Link>
//                                     </div>
//                                 </div>
//                             </div>
//                             <div className={classes.login}>
//                                 <LoginLogic>
//                                     <LoginHeaderContainer
//                                         greyTheme={true}
//                                         inWidget={true}
//                                     />
//                                 </LoginLogic>
//                             </div>
//                         </div>
//                     </Col>
//                 </Row>
//             </Container>
//         </div>
//     );
// };

// export default withStyles(styles)(MobileWindow);
import React from "react";
import classNames from "classnames";
import { Col } from "ComponentsUI/Styles/Grid";
import Container from "reactstrap/lib/Container";
import Row from "reactstrap/lib/Row";
import withStyles from "react-jss";
import SwitchCityWindowContainer from "Containers/SwitchCityWindowContainer";
// import DetectRegionContainer from "Containers/DetectRegionContainer";
import HeadMenuContainer from "Containers/HeadMenuContainer";
import PhoneContainerHeader from "Containers/PhoneContainerHeader";
import LoginHeaderContainer from "Containers/LoginHeaderContainer";
import LoginLogic from "HOC/LoginLogic";
import MainMenuContainer from "Containers/MainMenuContainer";

const styles = theme => {
    return {
        root: {
            visibility: "visible",
            opacity: 1,
            transition: "opacity .3s ease",
            position: "absolute",
            bottom: "-20px",
            transform: "translateY(100%)",
            width: "380px",
            background: theme.palette.colors.paleGrey,
            boxShadow: "0 2px 10px 0 rgba(0, 0, 0, 0.5)",
            borderRadius: "10px",
            right: "10px",
            padding: "15px 20px 30px",
        },
        showMobile: {},
        wrapperUpperPart: {
            padding: "10px 0",
            display: "flex",
            alignItems: "center",
        },
        wrapperBottomPart: {
            paddingTop: "20px",
        },
        location: {},
        upperMenu: {
            maxWidth: "100%",
            display: "flex",
            justifyContent: "center",
            marginBottom: "30px",
        },
        phoneButton: {
            display: "none",
        },
        login: {
            display: "flex",
            justifyContent: "center",
            width: "100%",
        },
        mobileMenu: {
            display: "block",
            marginLeft: "auto",
            flexShrink: 0,
            cursor: "pointer",
            "& span": {
                fontSize: "24px",
                color: theme.palette.colors.purplishBlue,
            },
        },
        hidden: {
            transform: "translateX(100%)",
            visibility: "hidden",
            opacity: 0,
        },
        [`@media (min-width: ${theme.media.sm}) and (max-width: ${theme.media.md})`]: {
            root: {
                right: "5px",
            },
        },
        [`@media (max-width: ${theme.media.sm})`]: {
            root: {
                display: "block",
                transform: "translateX(0)",
                transition: "transform .3s ease",
                position: "fixed",
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                backgroundColor: theme.palette.colors.paleGrey,
                zIndex: 10000,
                boxShadow: "none",
                width: "100%",
                padding: 0,
                borderRadius: 0,
            },
            hidden: {
                transform: "translateX(100%)",
            },
            wrapperUpperPart: {
                padding: "10px 0",
                display: "flex",
                alignItems: "center",
            },
            wrapperBottomPart: {
                paddingTop: "20px",
                maxHeight: "calc(100vh - 80px)",
                overflow: "scroll",
            },
            login: {
                flexShrink: 0,
            },
            phoneButton: {
                width: "40px",
                flexShrink: 0,
                marginLeft: "auto",
                display: "block",
            },
            location: {
                width: "auto",
                paddingLeft: 0,
                flexShrink: 5,
                minWidth: "10px",
                marginRight: "20px",
            },
            mobileMenu: {
                display: "flex",
                height: "40px",
                width: "40px",
                alignItems: "center",
                justifyContent: "center",
                marginLeft: "10px",
                flexShrink: 0,
                cursor: "pointer",
                "& span": {
                    fontSize: "16px",
                    color: theme.palette.colors.purplishBlue,
                },
            },
            upperMenu: {
                maxWidth: "100%",
                display: "flex",
                justifyContent: "center",
                marginBottom: "30px",
            },
        },
    };
};

class MobileWindow extends React.Component {
    render() {
        let classes = this.props.classes;
        return (
            <div
                ref={root => (this.root = root)}
                className={classNames(classes.root, {
                    [classes.hidden]: !this.props.show,
                })}
            >
                <Container>
                    <Row>
                        <Col xs="12">
                            <div className={classes.wrapperUpperPart}>
                                <div className={classes.location}>
                                    <SwitchCityWindowContainer
                                        mobileMenu
                                        purpleTheme={true}
                                        clickCallback={
                                            this.props.closeMobileMenu
                                        }
                                        wrapNameRegion={
                                            this.props.wrapNameRegion
                                        }
                                    />
                                </div>
                                <div className={classes.phoneButton}>
                                    <PhoneContainerHeader
                                        phone404={this.props.phone404}
                                    />
                                </div>
                                <div
                                    className={classes.mobileMenu}
                                    onClick={this.props.closeMobileMenu}
                                >
                                    <span className="icon24 icon-close" />
                                </div>
                            </div>
                            <div className={classes.wrapperBottomPart}>
                                <div className={classes.upperMenu}>
                                    <HeadMenuContainer
                                        inWidget={this.props.inWidget}
                                    />
                                </div>
                                <div className={classes.menu}>
                                    <MainMenuContainer
                                        inWidget={this.props.inWidget}
                                        onClickHandler={
                                            this.props.closeMobileMenu
                                        }
                                        withoutMain={true}
                                        purpleColor={true}
                                    />
                                </div>
                                <div className={classes.login}>
                                    <LoginLogic>
                                        <LoginHeaderContainer
                                            greyTheme={true}
                                            inWidget={true}
                                        />
                                    </LoginLogic>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        );
    }
}

export default withStyles(styles)(MobileWindow);
